<template>
  <div class="car-life-bd">
    <img class="img-cover" :src="imgUrlPrefix + picName" alt="METTA" />
    <div class="car-life-bd-content fade-up">
      <h5>METTA<br>硬派越野生活方式系列</h5>
      <p>我们提供从日常到极致的全场景越野体验<br>帮助每一位越野爱好者——向外探索，向内抵达</p>
      <div class="car-life-bd-btns">
        <button class="btn-black" @click.stop="toggleQrCode">即刻下订 →</button>
        <button class="btn-white" @click="$router.push({ path: '/metta-world', query: { scrollTo: 'car-series' } })">进入载具库</button>
        <!-- 二维码 -->
        <div class="qr-code-box" v-show="isQrVisible" @click.stop>
          <p class="qr-code-txt">即刻下订</p>
          <img class="qr-code-img" :src="`${imgUrlPrefix}qrcode.jpg`" alt="二维码" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fadeAnimate, destroyFadeAnimate } from '../../utils/animation.js'
export default {
  name: 'CarLifeBadainJaran',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    fadeAnimate();
    document.addEventListener('click', this.handleGlobalClick);
  },
  beforeDestroy() {
    destroyFadeAnimate();
    document.removeEventListener('click', this.handleGlobalClick);
  },
  computed: {
    picName() {
      return this.isMobile ? 'm-sec15_1.jpg' : 'sec15_1.jpg'
    },
  },
  data() {
    const imgUrlPrefix = '/assets/images/badainJaran/'
    return {
      imgUrlPrefix,
      isQrVisible: false,
    }
  },
  methods: {
    toggleQrCode() {
      this.isQrVisible = !this.isQrVisible;
    },
    // 新增：隐藏二维码
    hideQrCode() {
      this.isQrVisible = false;
    },
    handleGlobalClick() {
       
    }
  },
}
</script>

<style lang="less" scoped>
.car-life-bd {
  width: 100%;
  position: relative;
  aspect-ratio: 1920 / 1244;
  .car-life-bd-content {
    position: absolute;
    bottom: 5.37vw;
    left: 50%;
    transform: translateX(-50%);
    h5 {
      font-weight: @fw1;
      font-size: clamp(32px, 2.5vw, 48px);
      color: #fff;
      text-align: center;
    }
    p {
      margin-top: 0.83vw;
      font-weight: @fw2;
      font-size: clamp(16px, 1.25vw, 24px);
      color: #fff;
      text-align: center;
    }
    .car-life-bd-btns {
      display: flex; gap: 16px; justify-content: center;
      position: relative;
      width: 224px; margin: 24px auto 0;
      .btn-black {
        font-size: 10px;
        color: #000; background: #fff;
        padding: 10px 25px; font-family: inherit; font-weight: @fw2; cursor: pointer;
      }
      .btn-white {
        font-size: 10px; border: 1px solid rgba(255,255,255,0.2);
        color: #fff; background: transparent;
        padding: 10px 25px; font-family: inherit; font-weight: @fw2; cursor: pointer;
      }
      // 修改：二维码弹窗样式
      .qr-code-box {
        position: absolute;
        bottom: 140%; // 位于按钮上方
        left: -25px;
        background: #fff;
        padding: 20px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 20;
        // 添加一个小三角指向按钮（可选）
        &::after {
          content: '';
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          border-width: 6px;
          border-style: solid;
          border-color: #fff transparent transparent transparent;
        }

        .qr-code-txt {
          font-size: 14px;
          color: #000000;
          margin-bottom: 10px;
          font-weight: @fw2;
          margin-top: 0;
        }

        .qr-code-img {
          width: 125px; // 根据实际图片大小调整
          height: 125px;
          display: block;
        }
      }
    }

  }
}
@media (max-width: @mobile-width) {
  .car-life-bd {
    aspect-ratio: auto;
    .car-life-bd-content {
      inset: 0;
      transform: none;
      h5 {
        width: 52vw;
        margin: 21.33vw auto 2.67vw;
        font-size: 8.53vw;
        line-height: 1.4;
      }
      p {
        width: 52vw;
        margin: 0 auto;
        font-size: 4.26vw;
      }
      .car-life-bd-btns {
        margin-top: 9.33vw;
        width: auto;
        .btn-black, .btn-white {
          font-size: 4.26vw;
        }
        .btn-black { padding: 2.67vw 5.33vw; }
        .btn-white { padding: 2.67vw 6.67vw; }
        // 移动端二维码适配
        .qr-code-box {
          bottom: 130%;
          left: 30vw;
          transform: translateX(-50%);
          .qr-code-txt {
            font-size: 3.5vw;
            width: auto;
          }
          .qr-code-img {
            width: 30vw;
            height: 30vw;
          }
        }
      }
    }
  }
}
</style>